import {Nullable} from '../../../app/TypeHelpers'
import {Room} from './Room'
import {AssocDirectorPositionInfo} from './AssocDirectorPositionInfo'
import moment, {Moment} from 'moment'

export class AssocDirector {
    assocDirectorId: number
    adminId: string
    roomList: Room[]
    familyName: Nullable<string>
    firstName: Nullable<string>
    availableTermStartDate: Moment
    availableTermEndDate: Moment
    assocDirectorPositionInfoList: AssocDirectorPositionInfo[]
    version: number

    constructor(
        assocDirectorId: number,
        adminId: string,
        roomList: Room[],
        familyName: Nullable<string>,
        firstName: Nullable<string>,
        availableTermStartDate: Moment,
        availableTermEndDate: Moment,
        assocDirectorPositionInfoList: AssocDirectorPositionInfo[],
        version: number,
    ) {
        this.assocDirectorId = assocDirectorId
        this.adminId = adminId
        this.roomList = roomList
        this.familyName = familyName
        this.firstName = firstName
        this.availableTermStartDate = availableTermStartDate
        this.availableTermEndDate = availableTermEndDate
        this.assocDirectorPositionInfoList = assocDirectorPositionInfoList
        this.version = version
    }

    static from(json: any): AssocDirector {
        return new AssocDirector(
            json.assocDirectorId,
            json.adminId,
            json.roomList.map((room: any) => Room.from(room)),
            json.familyName,
            json.firstName,
            moment(json.availableTermStartDate),
            moment(json.availableTermEndDate),
            json.assocDirectorPositionInfoList
                .map((info: any) => AssocDirectorPositionInfo.from(info)),
            json.version,
        )
    }
}
